/**
 * Header.
 */
(() => {
    /**
     * A variable to store a timeout (for use with clearTimeout).
     */
    let debounceTimeout;

    /**
     * How often we should update header height when resizing.
     */
    const debounceDelay = 100;

    let header = document.querySelector('.js-site-header');

    if (!header) {
        return;
    }

    H_Tools?.header?.setHeight(header.clientHeight);

    new ResizeObserver((entries) => {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            const { height } = entries[entries.length - 1].contentRect;
            H_Tools?.header?.setHeight(height);
        }, debounceDelay);
    }).observe(header);
})();
